module.exports = __webpack_public_path__ + "static/media/QRApp.03bad71a.jpg";